import { defineAsyncComponent } from 'vue';
import DataBrowser from '@/src/components/DataBrowser.vue';
import WindowLevelControls from '@/src/components/tools/windowing/WindowLevelControls.vue';
import { Tools } from '@/src/store/tools/types';
import type {
  PanelDef,
  ToolbarPanelDef,
  ViewerModule,
} from '@/src/features/types';

const SegmentGroupControls = defineAsyncComponent(
  () => import('@/src/components/SegmentGroupControls.vue')
);
const MeshesModule = defineAsyncComponent(
  () => import('@/src/components/MeshesModule.vue')
);
const RenderingModule = defineAsyncComponent(
  () => import('@/src/components/RenderingModule.vue')
);
const PaintTool = defineAsyncComponent(
  () => import('@/src/components/tools/paint/PaintTool.vue')
);

const corePanels: PanelDef[] = [
  {
    id: 'data',
    label: 'Data',
    icon: 'mdi-database',
    component: DataBrowser,
  },
  {
    id: 'windowlevel',
    label: 'Window / Level',
    icon: 'mdi-circle-half-full',
    component: WindowLevelControls,
  },
  {
    id: 'segments',
    label: 'Segments',
    icon: 'mdi-layers',
    component: SegmentGroupControls,
  },
  {
    id: 'meshes',
    label: 'Meshes',
    icon: 'mdi-cube-scan',
    component: MeshesModule,
  },
  {
    id: 'rendering',
    label: '3D Rendering',
    icon: 'mdi-cube-outline',
    component: RenderingModule,
  },
];

const coreToolbarPanels: ToolbarPanelDef[] = corePanels.map(
  ({ id, label, icon }) => ({ id, label, icon })
);

export const coreModule: ViewerModule = {
  id: 'core',
  panels: corePanels,
  toolbarPanels: coreToolbarPanels,
  sliceTools: {
    paint: PaintTool,
  },
  autoOpenPanelOnTool: 'segments',
  autoOpenTools: [Tools.Paint],
};
